{
  "name": "bsv",
  "version": "1.5.6",
  "description": "A pure and powerful JavaScript Bitcoin SV (BSV) library.",
  "author": "Ryan X. Charles <ryan@moneybutton.com>",
  "main": "index.js",
  "scripts": {
    "lint": "standard",
    "test": "standard && mocha",
    "coverage": "nyc --reporter=text npm run test",
    "build-bsv": "webpack index.js --config webpack.config.js",
    "build-ecies": "webpack ecies/index.js --config webpack.subproject.config.js --output-library bsvEcies -o bsv-ecies.min.js",
    "build-message": "webpack message/index.js --config webpack.subproject.config.js --output-library bsvMessage -o bsv-message.min.js",
    "build-mnemonic": "webpack mnemonic/index.js --config webpack.subproject.config.js --output-library bsvMnemonic -o bsv-mnemonic.min.js",
    "build": "yarn build-bsv && yarn build-ecies && yarn build-message && yarn build-mnemonic",
    "prepublishOnly": "yarn build"
  },
  "unpkg": "bsv.min.js",
  "keywords": [
    "bitcoin",
    "transaction",
    "address",
    "p2p",
    "ecies",
    "cryptocurrency",
    "blockchain",
    "payment",
    "bip21",
    "bip32",
    "bip37",
    "bip69",
    "bip70",
    "multisig"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/moneybutton/bsv"
  },
  "browser": {
    "request": "browser-request"
  },
  "dependencies": {
    "aes-js": "^3.1.2",
    "bn.js": "=4.11.9",
    "bs58": "=4.0.1",
    "clone-deep": "^4.0.1",
    "elliptic": "6.5.4",
    "hash.js": "^1.1.7",
    "inherits": "2.0.3",
    "unorm": "1.4.1"
  },
  "devDependencies": {
    "brfs": "2.0.1",
    "chai": "4.2.0",
    "mocha": "^8.4.0",
    "nyc": "^14.1.1",
    "sinon": "7.2.3",
    "standard": "12.0.1",
    "webpack": "4.29.3",
    "webpack-cli": "^3.3.12"
  },
  "license": "MIT",
  "standard": {
    "globals": [
      "afterEach",
      "beforeEach",
      "describe",
      "it"
    ],
    "ignore": [
      "dist/**"
    ]
  }
}
